import $ from '$/jquery'
import ox from '$/ox'
import _ from '$/underscore'

(function () {
  const links = ox && ox.serverConfig && ox.serverConfig.loginLinks

  if (!links) return

  const lastLinkContainer = $('#io-ox-login-footer .composition-element a:last').parents('.composition-element')
  const insertAfter = lastLinkContainer
  const insertBefore = $('#io-ox-login-footer .composition-element.login-spacer:last')
  const insertIn = $('#io-ox-login-footer')

  function createLink (text, url) {
    let linkContainer

    if (lastLinkContainer.length) {
      linkContainer = lastLinkContainer.clone()
      if (links.linkColor) linkContainer.css('color', links.linkColor)
    } else {
      const sc = ox.serverConfig
      const linkColor = links.linkColor
        || (sc.loginPage && sc.loginPage.footer && sc.loginPage.footer.linkColor)
        || '#94c1ec'

      linkContainer = $('<div>')
        .addClass('composition-element')
        .append(
          $('<span>').append(
            $('<a>').css({ color: linkColor })
          )
        )
    }
    const linkSpan = linkContainer.find('span')
    const link = linkSpan.find('a')

    if (!link.length) {
      return $()
    }

    linkContainer.addClass('custom-login-links')
    linkSpan.removeClass()
    link.attr({
      href: url,
      target: 'blank'
    }).removeAttr('data-i18n').text(text)

    return linkContainer
  }

  function addFooterLinks (language) {
    $('#io-ox-login-footer .custom-login-links').remove()
    _.values(links).forEach(function (item) {
      const text = item.text && (item.text[language] || item.text.default)
      const url = item.href && (item.href[language] || item.href.default)
      if (text && url) {
        if (insertAfter.length) {
          insertAfter.after(createLink(text, url))
        } else if (insertBefore.length) {
          insertBefore.before(createLink(text, url))
        } else if (insertIn.length) {
          insertIn.append(createLink(text, url))
        }
      }
    })
  }

  // Update links on language change
  ox.on('language', function (id) {
    addFooterLinks(id)
  })

  addFooterLinks(ox.language)
})()
